/* eslint-disable no-nested-ternary */
/* eslint-disable no-use-before-define */
/* eslint-disable func-names */
/* eslint-disable no-bitwise */
/* eslint-disable no-unused-expressions */
import { useState, useEffect, useCallback } from 'react';
import {
  Route,
  Routes,
  Navigate,
  useLocation,
  useNavigate,
} from 'react-router-dom';
import './App.scss';
import Header from '../Header/Header';
import WelcomePage from '../../pages/Default/WelcomePage/WelcomePage';
import FPWelcomePage from '../../pages/FinancialPlanning/WelcomePage/FPWelcomePage';
import Quiz from '../../pages/Default/Quiz/Quiz';
import FPQuiz from '../../pages/FinancialPlanning/Quiz/FPQuiz';
import CustomizePage from '../../pages/Default/CustomizePage/CustomizePage';
import FPCustomizePage from '../../pages/FinancialPlanning/CustomizePage/FPCustomizePage';
import FPPlanningTopicsPage from '../../pages/FinancialPlanning/PlanningTopics/FPPlanningTopicsPage';
import ErrorPage from '../../pages/ErrorPage/ErrorPage';
import ResultsPage from '../../pages/Default/ResultsPage/ResultsPage';
import FPResultsPage from '../../pages/FinancialPlanning/ResultsPage/FPResultsPage';
import JonesFooter from '../JonesFooter/JonesFooter';
import LocaleContext from '../../contexts/LocaleContext';
import FeatureContext from '../../contexts/FeatureContext';
import useQuery from '../../utils/useQuery/useQuery';
import getSource from '../../utils/getSource/getSource';
import getConType from '../../utils/getConType/getConType';
import getText from '../../assets/locale/locale';
import LanguageSelect from '../LanguageSelect/LanguageSelect';
import {
  getSchema,
  isMpUsFinancialPlanningContentActive,
  handleAVIError,
} from '../../api';
import { useDataLayerInfo } from '../../contexts/DataLayerContext';
import getUserPersonaType from '../../utils/getUserPersonaType/getUserPersonaType';

import {
  LOCALE_EN_US,
  LOCALE_EN_CA,
  LOCALE_FR_CA,
  MY_PRIORITIES_APP_NAME_FRENCH,
} from '../../constants/constants';

import ValueDoc from '../../types/ValueDoc';
import AssessmentStartKit from '../../types/AssessmentStarterKit';
import ActiveValue from '../../types/ActiveValue';
import FaInfo from '../../types/FaInfo';
import UserPersonaTypes from '../../constants/UserPersonaTypes';
import UserContext from '../../contexts/UserContext';
import FeatureFlags from '../../types/api/FeatureFlags';
import FinancialPlanningContent from '../../types/pages/FinancialPlanning/FinancialPlanningContent';
import generateUUID from '../../utils/generateUUID/generateUUID';

/**
 * App should render the main content/component/container for an application
 */
const App = () => {
  const { setDataLayerInfo } = useDataLayerInfo();
  const [sessionId, setSessionId] = useState('');
  const [contactID, setContactID] = useState(null);
  const [financialAdvisorID, setFinancialAdvisorID] = useState(null);
  const [entityID, setEntityID] = useState(null);
  const [timestamp, setTimestamp] = useState(null);
  const [utmSource, setUtmSource] = useState(null);
  const [utmContent, setUtmContent] = useState(null);
  const [callerApp, setCallerApp] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [contactName, setContactName] = useState({
    firstName: '',
    lastName: '',
  });
  const [initialValuePair, setInitialValuePair] = useState([]);
  const [quizIsStarted, setQuizStarted] = useState(false);
  const [isLoading, setLoading] = useState(true);
  const [isErrorReceivedFromAPI, setIsErrorReceivedFromAPI] = useState(false);
  const [finalResultsIndex, setFinalResultsIndex] = useState<number[]>([]);
  const [paramsFetched, setParamsFetched] = useState(false);
  const [activeValueList, setActiveValueList] = useState<Array<ActiveValue>>(
    []
  );
  const [quizRestarted, setQuizRestarted] = useState(false);
  const [displaySendToFAButton, setDisplaySendToFAButton] = useState(false);
  const [faInfo, setFaInfo] = useState<FaInfo>({
    faFirstName: null,
    faLastName: null,
    faPrimaryEmail: null,
    faTeamEmail: null,
    branchNo: null,
    faNo: null,
    faPhoto: null,
    entityIdBase64: null,
  });
  const [featureFlags, setFeatureFlags] = useState<FeatureFlags | null>(null);
  const location = useLocation();
  const navigate = useNavigate();
  const urlQuery = useQuery();
  const [userPersona, setUserPersona] = useState<UserPersonaTypes | null>(null);
  const personaTypeArrayUS = Array.of(
    UserPersonaTypes.WORD_POWER,
    UserPersonaTypes.NEWS_LETTER,
    UserPersonaTypes.PERSONAL_LINK,
    UserPersonaTypes.PERSONAL_LINK_FA_PROFILE,
    UserPersonaTypes.FINANCIAL_FOUNDATION,
    UserPersonaTypes.DIRECT_URL
  );
  const [financialPlanningContent, setFinancialPlanningContent] =
    useState<FinancialPlanningContent>(
      undefined as unknown as FinancialPlanningContent
    );

  const locId = ((): string => {
    const localeRegex = /^(fr_(CA|ca))|(en_(US|us|CA|ca))$/;
    let locale = LOCALE_EN_US;

    const localeQueryParam = urlQuery.get('locale');
    if (
      localeQueryParam &&
      localeQueryParam.length === 5 &&
      localeRegex.test(localeQueryParam)
    ) {
      if (localeQueryParam.toLowerCase() === LOCALE_FR_CA.toLowerCase()) {
        locale = LOCALE_FR_CA;
      } else if (
        localeQueryParam.toLowerCase() === LOCALE_EN_CA.toLowerCase()
      ) {
        locale = LOCALE_EN_CA;
      } else if (
        localeQueryParam.toLowerCase() === LOCALE_EN_US.toLowerCase()
      ) {
        locale = LOCALE_EN_US;
      }
    }

    if (window.location.href.includes('.ca')) {
      if (window.location.href.includes(MY_PRIORITIES_APP_NAME_FRENCH)) {
        locale = LOCALE_FR_CA;
      } else {
        locale = LOCALE_EN_CA;
      }
    }
    return locale;
  })();

  // Prevent React from recreating this function reference when re-rendering
  const handleBeforeUnload = useCallback((event) => {
    event.preventDefault();
  }, []);

  const removeBeforeUnloadEventListener = () => {
    window.removeEventListener('beforeunload', handleBeforeUnload);
  };

  const addBeforeUnloadEventListener = () => {
    window.addEventListener('beforeunload', handleBeforeUnload);
  };

  useEffect(() => {
    getURLParams();
    addBeforeUnloadEventListener();
    const newSessionId = generateUUID();
    const dataLayerInfo = {
      page_type: 'home-page',
      locale: locId,
      environment: window.ENVIRONMENT,
      sessionId: newSessionId,
      fa_no: urlQuery.get('faNo') ?? undefined,
      fa_entity_id: urlQuery.get('EID') ?? undefined,
    };
    setSessionId(newSessionId);
    setDataLayerInfo(dataLayerInfo);
    return () => {
      removeBeforeUnloadEventListener();
    };
  }, []);

  useEffect(() => {
    if (paramsFetched) {
      initialFetch();
      getFeaturesFlags();
    }
  }, [paramsFetched]);

  useEffect(() => {
    if (activeValueList.length > 0) {
      setInitialValuePair(determineFirstPair(activeValueList));
    }
  }, [activeValueList]);

  useEffect(() => {
    setQuizStarted(false);
  }, [finalResultsIndex]);

  function getURLParams() {
    const queryFaNumber = urlQuery.get('faNo');
    const queryEntityID = urlQuery.get('EID');
    const queryContactID = urlQuery.get('conId');
    const queryCreatedTimestamp = urlQuery.get('creTS');
    const queryUtmSource = urlQuery.get('utm_source');
    const queryUtmContent = urlQuery.get('utm_content');
    const queryCallerAppName = urlQuery.get('callerAppName');

    const queryContactType = !urlQuery.get('conType')
      ? getConType(queryUtmSource, queryUtmContent)
      : urlQuery.get('conType');

    setTimestamp(queryCreatedTimestamp);
    setUtmSource(queryUtmSource);
    setUtmContent(queryUtmContent);
    setCallerApp(queryCallerAppName);
    if (queryContactID) {
      setContactID(queryContactID);
    }
    if (queryFaNumber) {
      setFinancialAdvisorID(queryFaNumber);
    }
    if (queryEntityID) {
      setEntityID(queryEntityID);
    }
    setParamsFetched(true);
    setUserPersona(
      getUserPersonaType(
        queryFaNumber,
        queryEntityID,
        queryContactID,
        queryContactType,
        queryCreatedTimestamp,
        queryUtmSource,
        locId
      )
    );
  }

  function initialFetch() {
    getSchema(
      locId,
      contactID,
      getSource(utmSource, entityID, financialAdvisorID, contactID),
      getConType(utmSource, utmContent),
      financialAdvisorID,
      entityID
    )
      .then((res: AssessmentStartKit) => {
        setContactName({
          firstName: res.mpContact.firstName,
          lastName: res.mpContact.lastName,
        });
        setActiveValueList(
          res.fullAssessment.map((value: ValueDoc) => {
            const newValue: ActiveValue = {
              statementId: value.statementId,
              statementRank: value.statementRank,
              statementText: value.statementText,
              learnMoreContent: value.learnMoreContent,
              learnMoreLinks: value.learnMoreLinks,
              isActive: value.isDefault || value.isDefault === null,
              indexId: value.statementId,
              additionalInfo: value.additionalInfo,
            };
            setDisplaySendToFAButton(res.isSendToFAButtonDisplayed);
            res.faInfo ? setFaInfo(res.faInfo) : null;
            if (res.faInfo && res.faInfo.entityIdBase64) {
              // update DataLayer Context with FA info
              setDataLayerInfo((prev) => ({
                ...prev,
                fa_no: res.faInfo.faNo,
                fa_entity_id: res.faInfo.entityIdBase64,
                sessionId,
                locale: locId,
              }));
              setEntityID(res.faInfo.entityIdBase64);
            } else {
              setDataLayerInfo((prev) => ({
                ...prev,
                sessionId,
              }));
            }

            return newValue;
          })
        );
        setLoading(false);
      })
      .catch((error) => {
        if (error.response && error.response.status === 403) {
          handleAVIError(error, locId);
        }
        errorPageCallback();
      });
  }

  function showFPContent() {
    return (
      featureFlags &&
      featureFlags.usFinancialPlanningContentActive &&
      userPersona &&
      personaTypeArrayUS.includes(userPersona)
    );
  }

  function getFeaturesFlags() {
    isMpUsFinancialPlanningContentActive()
      .then((res) => {
        setFeatureFlags({
          ...featureFlags,
          usFinancialPlanningContentActive: res,
        });
      })
      .catch((err) =>
        /* eslint-disable no-console */
        console.error(
          `Error occured getting features: ${err}\nServing up base model...`
        )
      );
  }

  function determineFirstPair(valueList: Array<ActiveValue>) {
    let largest = 0;
    let secondLargest = 0;
    const firstPair: Array<ActiveValue> = [{}, {}];
    valueList.forEach((value: ActiveValue) => {
      if (value.isActive) {
        if (value.statementRank > secondLargest) {
          if (value.statementRank > largest) {
            secondLargest = largest;
            largest = value.statementRank;
            firstPair.unshift(value); // add value.statemendId as first ele
            firstPair.pop(); // remove last ele, keeping 2 elements
          } else {
            secondLargest = value.statementRank;
            firstPair.pop(); // remove last ele
            firstPair.push(value); // add value.statementId as last ele
          }
        }
      }
    });
    return firstPair;
  }

  function errorPageCallback() {
    setIsErrorReceivedFromAPI(true);
    navigate(getText(locId, 'errorPath', 'app') + location.search);
  }

  function resetWelcomePage() {
    setQuizStarted(false);
    setIsErrorReceivedFromAPI(false);
  }

  const restartCallback = () => {
    window.scroll(0, 0);
    setFinalResultsIndex([]);
    setQuizStarted(false);
    setQuizRestarted(true);
    navigate(getText(locId, 'customizePath', 'app') + location.search);
  };

  return (
    <FeatureContext.Provider value={featureFlags}>
      <UserContext.Provider value={userPersona}>
        <LocaleContext.Provider value={locId}>
          <div id="content" data-testid="content-wrapper">
            <div className="skip-container">
              <a className="skip-link" href="#main-content">
                {getText(locId, 'skipLinkText', 'app')}
              </a>
            </div>
            <LanguageSelect
              addBeforeUnloadEventListener={addBeforeUnloadEventListener}
              removeBeforeUnloadEventListener={removeBeforeUnloadEventListener}
            />
            <Header />
            <div id="main-content">
              <Routes location={location}>
                <Route
                  path="/"
                  element={
                    showFPContent() ? (
                      <FPWelcomePage
                        customizeBtnCallback={() => {
                          navigate({
                            pathname: getText(locId, 'customizePath', 'app'),
                            search: location.search,
                          });
                        }}
                        isLoading={isLoading}
                      />
                    ) : (
                      <WelcomePage
                        contactName={contactName}
                        customizeBtnCallback={() => {
                          navigate({
                            pathname: getText(locId, 'customizePath', 'app'),
                            search: location.search,
                          });
                        }}
                        isLoading={isLoading}
                      />
                    )
                  }
                />
                <Route
                  path={getText(locId, 'customizePath', 'app')}
                  element={
                    showFPContent() ? (
                      <FPCustomizePage
                        valueList={activeValueList}
                        setInitialValuePair={setInitialValuePair}
                        customizePageBtnCallback={(
                          valueList: Array<ActiveValue>
                        ) => {
                          setQuizStarted(true);
                          setActiveValueList(valueList);
                          navigate(getText(locId, 'quizPath', 'app') + location.search);
                        }}
                        restart={quizRestarted}
                        isLoading={isLoading}
                      />
                    ) : (
                      <CustomizePage
                        valueList={activeValueList}
                        setInitialValuePair={setInitialValuePair}
                        customizePageBtnCallback={(
                          valueList: Array<ActiveValue>
                        ) => {
                          setQuizStarted(true);
                          setActiveValueList(valueList);
                          navigate(getText(locId, 'quizPath', 'app') + location.search);
                        }}
                        restart={quizRestarted}
                        isLoading={isLoading}
                      />
                    )
                  }
                />
                <Route
                  path={getText(locId, 'quizPath', 'app')}
                  element={
                    quizIsStarted ? (
                      showFPContent() ? (
                        <FPQuiz
                          initialValuePair={initialValuePair}
                          valueList={activeValueList.filter(
                            (value) => value.isActive
                          )}
                          errorPageCallback={() => {
                            errorPageCallback();
                          }}
                          finalResultsCallBack={(results) => {
                            setFinalResultsIndex(results);
                            navigate(
                              (userPersona !== UserPersonaTypes.DIRECT_URL
                                ? getText(locId, 'planningPath', 'app')
                                : getText(locId, 'resultsPath', 'app')
                              ) + location.search
                            );
                          }}
                        />
                      ) : (
                        <Quiz
                          initialValuePair={initialValuePair}
                          valueList={activeValueList.filter(
                            (value) => value.isActive
                          )}
                          errorPageCallback={() => {
                            errorPageCallback();
                          }}
                          finalResultsCallBack={(results) => {
                            setFinalResultsIndex(results);
                            navigate(getText(locId, 'resultsPath', 'app') + location.search);
                          }}
                        />
                      )
                    ) : (
                      <Navigate
                        to={{
                          pathname: getText(locId, 'resultsPath', 'app'),
                          search: location.search,
                        }}
                      />
                    )
                  }
                />
                <Route
                  path={getText(locId, 'planningPath', 'app')}
                  element={
                    (() => {
                      if (finalResultsIndex.length !== 0) {
                        if (
                          showFPContent() &&
                          userPersona !== UserPersonaTypes.DIRECT_URL
                        ) {
                          return (
                            <FPPlanningTopicsPage
                              planningTopicsBtnCallback={() => {
                                navigate({
                                  pathname: getText(locId, 'resultsPath', 'app'),
                                  search: location.search,
                                });
                              }}
                              isLoading={isLoading}
                              updateFinancialPlanningContent={
                                setFinancialPlanningContent
                              }
                              financialPlanningContent={
                                financialPlanningContent ?? undefined
                              }
                            />
                          );
                        }
                        return (
                          <Navigate
                            to={{
                              pathname: getText(locId, 'resultsPath', 'app'),
                              search: location.search,
                            }}
                          />
                        );
                      }
                      return (
                        <Navigate
                          to={{
                            pathname: '/',
                            search: location.search,
                          }}
                        />
                      );
                    })()
                  }
                />
                <Route
                  path={getText(locId, 'resultsPath', 'app')}
                  element={
                    finalResultsIndex.length !== 0 ? (
                      showFPContent() ? (
                        <FPResultsPage
                          contactID={contactID}
                          contactName={contactName}
                          financialAdvisorID={financialAdvisorID}
                          entityID={entityID}
                          timestamp={timestamp}
                          callerApp={callerApp}
                          finalResultsIndex={finalResultsIndex}
                          valueList={activeValueList.filter(
                            (value) => value.isActive
                          )}
                          sessionId={sessionId}
                          displaySendToFAButton={displaySendToFAButton}
                          faInfo={faInfo}
                          restartCallback={() => {
                            restartCallback();
                          }}
                          financialPlanningContent={financialPlanningContent}
                          userPersona={userPersona ?? UserPersonaTypes.DIRECT_URL}
                        />
                      ) : (
                        <ResultsPage
                          contactID={contactID}
                          contactName={contactName}
                          financialAdvisorID={financialAdvisorID}
                          entityID={entityID}
                          timestamp={timestamp}
                          callerApp={callerApp}
                          finalResultsIndex={finalResultsIndex}
                          valueList={activeValueList.filter(
                            (value) => value.isActive
                          )}
                          sessionId={sessionId}
                          displaySendToFAButton={displaySendToFAButton}
                          faInfo={faInfo}
                          restartCallback={() => {
                            restartCallback();
                          }}
                        />
                      )
                    ) : (
                      <Navigate
                        to={{
                          pathname: '/',
                          search: location.search,
                        }}
                      />
                    )
                  }
                />
                <Route
                  path={getText(locId, 'errorPath', 'app')}
                  element={
                    isErrorReceivedFromAPI ? (
                      <ErrorPage
                        quizIsStarted={quizIsStarted}
                        resetWelcomePage={() => {
                          resetWelcomePage();
                        }}
                      />
                    ) : (
                      <Navigate
                        to={{
                          pathname: '/',
                          search: location.search,
                        }}
                      />
                    )
                  }
                />
                <Route
                  path="*"
                  element={
                    <Navigate
                      to={{
                        pathname: '/',
                        search: location.search,
                      }}
                    />
                  }
                />
              </Routes>
            </div>
            <div data-testid="footer">
              <JonesFooter />
            </div>
          </div>
        </LocaleContext.Provider>
      </UserContext.Provider>
    </FeatureContext.Provider>
  );
};

export default App;
